<template>
  <div class="cmp-container">
    <div
      class="cmp"
      :class="[{ cmp_flipped: flipped }, { cmp_centered: isCentered }, { cmp_skeleton: skeleton }]"
    >
      <div class="cmp_legend gw_hvr">
        <div
          class="cmp_legend_left"
          :style="getLegendClr(pLeft, pRight, 'left')"
        >
          <slot name="legend_left" />
        </div>
        <div class="cmp_legend_center">
          <slot name="legend_center" />
        </div>
        <div
          class="cmp_legend_right"
          :style="getLegendClr(pRight, pLeft, 'right')"
        >
          <slot name="legend_right" />
        </div>
      </div>
      <div
        v-if="hasChart"
        class="cmp_chart"
      >
        <div
          v-show="pLeft"
          class="cmp_chart_bar cmp_chart_left"
          :style="`width:${pLeft * (isCentered ? 0.5 : 1) * 100}%; background:${
            pRight === pLeft
              ? 'var(--clr-equal-left)'
              : pLeft > pRight
                ? 'var(--clr-back-winn)'
                : 'var(--clr-back-lose)'
          }`"
        ></div>
        <div
          v-show="pRight"
          class="cmp_chart_bar cmp_chart_right"
          :style="`width:${pRight * (isCentered ? 0.5 : 1) * 100}%; background:${
            pRight === pLeft
              ? 'var(--clr-equal-right)'
              : pRight > pLeft
                ? 'var(--clr-back-winn)'
                : 'var(--clr-back-lose)'
          }`"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompareChartBox',
  props: {
    skeleton: Boolean,
    item: Object,
    flipped: Boolean,
    isCentered: Boolean,
    hasChart: { type: Boolean, default: true },
    // isHoverable: Boolean,
    isActive: Boolean,
    hasColoredLegend: Boolean,
    pLeft: { default: 0 },
    pRight: { default: 0 },
  },
  data() {
    return {}
  },
  methods: {
    getLegendClr(a, b, part) {
      if (!this.hasColoredLegend) return ''
      return `--clr-legend:${
        a === b
          ? `var(--clr-equal-${part})`
          : a > b
            ? `var(--clr-winn-${part})`
            : `var(--clr-lose-${part})`
      }`
    },
  },
}
</script>

<style lang="scss" scoped>
.cmp-container {
  display: flex;
  flex: 1;
  --chart-height: var(--height-chart-small);

  --grid-gap: 0.5px;
  --border-radius: 4px;

  --weight: 400;
  --weight-legend: 400;
  --size-legend-center: inherit;

  --clr-legend: var(--clr-white-0);
  --clr-legend-center: var(--clr-white-0);
  --clr-legend-center-skeleton: var(--clr-grey-2);
  --clr-back-legend-active: var(--clr-black-3);
  --clr-back-legend-hover: var(--clr-black-1-3);

  --clr-back-lose: var(--clr-black-4);
  --clr-back-winn: var(--clr-primary);

  --clr-lose: var(--clr-error);
  --clr-lose-left: var(--clr-lose);
  --clr-lose-right: var(--clr-lose);

  --clr-winn: var(--clr-primary);
  --clr-winn-left: var(--clr-winn);
  --clr-winn-right: var(--clr-winn);

  --clr-equal: var(--clr-primary);
  --clr-equal-left: var(--clr-equal);
  --clr-equal-right: var(--clr-equal);
}

.cmp {
  display: flex;
  flex-direction: column;
  width: 100%;
  font-weight: var(--weight);
  &_flipped {
    .cmp_legend,
    .cmp_chart {
      direction: rtl;
    }
  }
  &_chart {
    display: flex;
    grid-gap: var(--grid-gap);
    width: 100%;
    height: var(--chart-height);
    overflow: hidden;
    border-radius: var(--border-radius);
    position: relative;
    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      background: var(--clr-black-3);
      border-radius: var(--border-radius);
    }
    &_bar {
      height: 100%;
    }
    &_left {
      height: 100%;
      display: flex;
      justify-content: flex-end;
      position: relative;
    }
    &_right {
      height: 100%;
      display: flex;
      justify-content: flex-start;
      position: relative;
    }
  }
  &_centered {
    .cmp_chart {
      display: flex;
      grid-gap: var(--grid-gap);
      width: 100%;
      height: var(--chart-height);
      overflow: hidden;
      border-radius: var(--border-radius);
      position: relative;
      &_bar {
        height: 100%;
      }
      &_left,
      &_right {
        height: 100%;
        position: absolute;
      }
      &_left {
        right: calc(50% + calc(0.5 * var(--grid-gap)));
        &.cmp_chart_bar {
          border-radius: 1px 0 0 1px;
        }
      }
      &_right {
        left: calc(50% + calc(0.5 * var(--grid-gap)));
        &.cmp_chart_bar {
          border-radius: 0 1px 1px 0;
        }
      }
    }
    &.cmp_flipped {
      .cmp_chart {
        &_left {
          right: unset;
          left: calc(50% + calc(0.5 * var(--grid-gap)));
        }
        &_right {
          left: unset;
          right: calc(50% + calc(0.5 * var(--grid-gap)));
        }
      }
    }
  }
  &_skeleton {
    .cmp_legend {
      &_left,
      &_right {
        color: transparent;
      }
      &_center {
        color: var(--clr-legend-center-skeleton);
      }
    }
    .cmp_chart {
      &_left,
      &_right {
        display: none;
      }
    }
  }
  &_legend {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    width: 100%;
    &_left {
      display: flex;
      justify-content: flex-start;
      position: relative;
      color: var(--clr-legend);
      z-index: 1;
    }
    &_center {
      display: flex;
      justify-content: center;
      position: relative;
      align-items: center;
      font-size: var(--size-legend-center);
      font-weight: var(--weight-legend);
      color: var(--clr-legend-center);
      width: 100%;
      z-index: 2;
    }
    &_right {
      display: flex;
      justify-content: flex-end;
      position: relative;
      color: var(--clr-legend);
      z-index: 1;
    }
  }
}
</style>
